import { fetchData } from '../../../shared/utils';
import type { Filter } from '../../../shared/types/podlet';
import type { ReklameConfiguration } from '../../../shared/types/reklameMaster';
import { DeviceType } from '../../../shared/types/ast';
import { displayAdsLog } from '../../utils/debug';

export async function getSearchReklameConfig(
    device: DeviceType,
    searchFilters: Filter,
    baseUrl: string,
): Promise<ReklameConfiguration> {
    const url = `${baseUrl}/search-config`;
    try {
        const { search_key, ...search_filters } = searchFilters;
        const body = {
            platform: 'web',
            device: device === 'mobile' ? 'phone' : device,
            search_key,
            search_filters: search_filters || {},
        };

        const response = await fetchData(url, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!response) {
            displayAdsLog(
                `Did not getSearchReklameConfig response from ${url} for ${JSON.stringify(
                    body,
                )}`,
            );
            return null;
        }
        return response as ReklameConfiguration;
    } catch (e) {
        throw new Error(`Unable to get reklame configuration - error: ${e}`);
    }
}
